module.exports = __webpack_public_path__ + "static/img/bg-overview@t.2191f73.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/bg-overview@t.jpg
// module id = 17w+
// module chunks = 0